import(/* webpackMode: "eager" */ "/vercel/path0/src/app/register/freelancer/page.tsx");
